export const FETCH_MAILS_REQUEST = 'FETCH_MAILS_REQUEST'
export const FETCH_MAILS_SUCCESS = 'FETCH_MAILS_SUCCESS'
export const FETCH_MAILS_FAILURE = 'FETCH_MAILS_FAILURE'

const fetchMailsRequest = () => ({
  type: FETCH_MAILS_REQUEST
})

const fetchMailsSuccess = data => ({
  type: FETCH_MAILS_SUCCESS,
  payload: data
})

const fetchMailsFailure = error => ({
  type: FETCH_MAILS_FAILURE,
  payload: error
})

const singleZeptoMailSender = (tenant, body, mail) => {
  return async dispatch => {
    dispatch(fetchMailsRequest())
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('mail')}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok) {
        throw new Error('Failed to retrieve mails')
      }
      const data = await response.json()
      dispatch(fetchMailsSuccess(data.data || []))
    } catch (error) {
      dispatch(fetchMailsFailure(error.message))
    }
  }
}

const bulkZeptoMailSender = tenant => {
  return async dispatch => {
    dispatch(fetchMailsRequest())
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('mail')}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok) {
        throw new Error('Failed to retrieve mails')
      }
      const data = await response.json()
      dispatch(fetchMailsSuccess(data.data || []))
    } catch (error) {
      dispatch(fetchMailsFailure(error.message))
    }
  }
}

export {
  fetchMailsRequest,
  fetchMailsSuccess,
  fetchMailsFailure,
  singleZeptoMailSender,
  bulkZeptoMailSender
}
